import React from 'react';

const LazyComponent = ({Component, ...props}) => (
  <React.Suspense fallback={'<p>Loading...</p>'}>
    <Component {...props} />
  </React.Suspense>
);

export default LazyComponent;